<script>
    import {mapState, mapActions, mapGetters} from 'vuex'
    export default {
        props: {
            label: String,
            value: String,
            disabled: {
                type: Boolean,
                default: false,
            },
            clearable: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                val: 0,
            }
        },
        methods: {
            change(v){
                this.$emit('change', v);
                this.$emit('input', v);
            }
        },
        computed: {
            pickerOptions(){
                return{
                    firstDayOfWeek: 1,
                }
            }
        },
        watch: {
            value(v){
                this.val= v;
            },
            val(v){
                this.$emit('input', v);
            },
        },
        components: {},
        mounted() {
            this.val = this.value;

        },
        destroyed() {
        },
    }
</script>
<template>
    <div class="input-date">
        <div class="el-input-group el-input--mini" :class="{'el-input-group--prepend': label}">
            <div class="el-input-group__prepend" v-if="label">
                {{label}}
            </div>
            <el-date-picker
                    v-model="val"
                    type="date"
                    format="dd.MM.yyyy"
                    value-format="dd.MM.yyyy"
                    @change="change"
                    :clearable="clearable"
                    :disabled="disabled"
                    :default-value="new Date()"
                    :picker-options="pickerOptions">
            </el-date-picker>
        </div>
    </div>
</template>
<style lang="scss">
    .input-date {
        position: relative;
        .el-date-editor{
            width: 100%;
        }
    }
</style>
